import { render, staticRenderFns } from "./MsgBoardDialog.vue?vue&type=template&id=40e3659b&scoped=true&"
import script from "./MsgBoardDialog.vue?vue&type=script&lang=ts&"
export * from "./MsgBoardDialog.vue?vue&type=script&lang=ts&"
import style0 from "./MsgBoardDialog.vue?vue&type=style&index=0&id=40e3659b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e3659b",
  null
  
)

export default component.exports